var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.5C10.2956 3.5 11.0587 3.81607 11.6213 4.37868C12.1839 4.94129 12.5 5.70435 12.5 6.5C12.5 7.29565 12.1839 8.05871 11.6213 8.62132C11.0587 9.18393 10.2956 9.5 9.5 9.5C8.70435 9.5 7.94129 9.18393 7.37868 8.62132C6.81607 8.05871 6.5 7.29565 6.5 6.5C6.5 5.70435 6.81607 4.94129 7.37868 4.37868C7.94129 3.81607 8.70435 3.5 9.5 3.5ZM9.5 11C12.815 11 15.5 12.3425 15.5 14V15.5H3.5V14C3.5 12.3425 6.185 11 9.5 11Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlack);
export default __webpack_public_path__ + "static/media/user-black.f5462ffa896dbaabde1ff17a3442e5a8.svg";
export { ForwardRef as ReactComponent };